import { IUpdateUsersPermissionsActionPayload } from '../interfaces/update-users-permissions.action-payload.interface';

export class AddUserPermissions {
    static readonly type = '[User] AddUserPermissions';

    constructor(public payload: IUpdateUsersPermissionsActionPayload) {}
}
